module.exports = {"product":"Product","products":"Producten","name":"Naam","group":"Groep","vat_category":"BTW","price":"Prijs","description":"Omscrijving","list":{"title":"Producten","empty":"Geen producten gevonden","create_first":"Maak uw eerste product aan"},"manage":{"edit":"Producten wijzigen","create":"Nieuwe product aanmaken"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/product.json
// module id = u6RF
// module chunks = 15